import { IChuongTrinhDaoTaoKienThucActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoKienThucActions";
import { IChuongTrinhDaoTaoKienThucReducer } from "../../reducer-model/chuong-trinh-dao-tao/IChuongTrinhDaoTaoKienThucReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoKienThucReducer = {
  status: eReducerStatusBase.is_not_initialization,
  chuongTrinhDaoTaoKienThucs: [],
};
export const chuongTrinhDaoTaoKienThucReducer = (
  state: IChuongTrinhDaoTaoKienThucReducer = iniState,
  action: IChuongTrinhDaoTaoKienThucActionTypes
): IChuongTrinhDaoTaoKienThucReducer => {
  switch (action.type) {
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuongTrinhDaoTaoKienThucs: action.payload,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
